import { FC, useEffect, useState } from 'react';
import classNames from 'classnames';

import styles from 'src/styles/common/templateGallery.module.scss';
import { StateFormReturnType } from 'src/utils/stateForm';
import { UiAdditionalBlockAnimator } from 'src/components/common/Animator/AdditionalBlock';
import { useNsTHelper } from 'src/utils/i18n';
import { TemplateGalleryTitle } from 'src/components/Modals/TemplateGallery/components/Title';
import { FormValues } from 'src/components/Modals/TemplateGallery/screens/All/index';
import { TemplateGallerySearchInput } from 'src/components/Modals/TemplateGallery/screens/All/SearchInput';
import { SearchIcon } from 'src/components/Icons/Search';

type Props = {
  isMobile: boolean;
  formProps: StateFormReturnType<FormValues>;
  templatesNames: string[];
  getTemplates: () => void;
};

export const TemplateGallerySearchBar: FC<Props> = ({ isMobile, formProps, templatesNames, getTemplates }) => {
  const tHelper = useNsTHelper('modals.templateGallery', 'all');

  const [showInput, setShowInput] = useState(!isMobile);

  useEffect(() => setShowInput(!isMobile), [isMobile]);

  return (
    <div className={styles.searchBar}>
      <TemplateGalleryTitle screen="all">{tHelper('title')}</TemplateGalleryTitle>
      {isMobile && (
        <div
          role="presentation"
          onClick={() => setShowInput((prevState) => !prevState)}
          className={classNames(styles.iconWrapper, showInput && styles.active)}
        >
          <SearchIcon className={styles.icon} />
        </div>
      )}
      <UiAdditionalBlockAnimator show={showInput} className={styles.animator}>
        <TemplateGallerySearchInput formProps={formProps} templatesNames={templatesNames} getTemplates={getTemplates} />
      </UiAdditionalBlockAnimator>
    </div>
  );
};
